import { useCallback } from 'react';

type SortOrder = 'asc' | 'desc';

interface UseTableSortOptions<T extends string> {
  sortBy: T | '';
  sortOrder: SortOrder;
  onSortChange: (updates: { sortBy: T; sortOrder: SortOrder }) => void;
}

interface UseTableSortResult<T extends string> {
  sortBy: T | '';
  sortOrder: SortOrder;
  handleSort: (field: T) => void;
}

export default function useTableSort<T extends string>({
  sortBy,
  sortOrder,
  onSortChange,
}: UseTableSortOptions<T>): UseTableSortResult<T> {
  const handleSort = useCallback(
    (field: T) => {
      if (sortBy === field) {
        const newOrder: SortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        onSortChange({ sortBy: field, sortOrder: newOrder });
      } else {
        onSortChange({ sortBy: field, sortOrder: 'desc' });
      }
    },
    [sortBy, sortOrder, onSortChange],
  );

  return { sortBy, sortOrder, handleSort };
}
